<template>
    <!--    数字听书-->
    <div class="contain_item">
        <router-link class="box_class"
                     :to="{name:'AudioBook', params:{code:itemData.code}}"
        >
            <img class="img_class" :src="itemData.cover" alt=""/>
            <div class="title_class">
                {{itemData.title}}
            </div>
        </router-link>
    </div>
</template>

<script>
export default{
    name:'audioBook',
    props:{
        itemProp:{
            type: Object,
            default(){
                return {}
            },
        }
    },
    data(){
        return {
            itemData:{}
        }
    },
    created(){
        this.initData()
    },
    methods:{
        initData(){
            this.itemData = this.itemProp;
            this.itemData.title = this.itemData.title || '';
            this.itemData.cover = this.itemData.cover || ''
        }
    }

}

</script>

<style scoped>
.contain_item{
    position: relative;
    text-align: center;
    width: 36vw;
    margin-top: 10px;
}

.box_class{
    /*position: ;*/
}
.img_class{
    width:100%;
    height:24vw;
    object-fit: cover;
}
.title_class{
    position: absolute;
    bottom: 4vw;
    left: 3vw;
    color: #FFF;
}


</style>
